import script from "./9AT.vue?vue&type=script&setup=true&lang=js"
export * from "./9AT.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__